import * as _ from "lodash";

import { memoize, TS } from "@ctra/utils";

import { TableData } from "../typings";
import { Base } from "./Base";

/**
 * X axis data type date class
 *
 * Named as Day and not Date to avoid any confusion with the Javascript Date class
 */
class Day extends Base {
  /**
   * Format xAxis data
   * @param {T} value
   * @returns {T}
   */
  @memoize
  formatXAxis<T extends number | string>(value: T): T {
    return _.isString(value) ? (TS.asMoment(value).format("YYYY-MM-DD") as T) : value;
  }

  /**
   * Format table data
   * @param {TableData["data"]} data
   * @returns {TableData["data"]}
   */
  @memoize
  formatTableData(data: TableData["data"]): TableData["data"] {
    // @ts-expect-error
    return _.sortBy(data, (item) => new Date(item.key).valueOf());
  }
}

export { Day };
